<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12" md="9" xl="10">
              <v-btn
                class="mx-1"
                color="primary"
                title="Agregar Estudiantes"
                small
                @click="$refs.modalInscripcionesRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Agregar Estudiantes
              </v-btn>

              <v-btn small class="mx-1" :disabled="item == null" title="Quitar" @click="() => quitarItem(item.id)">
                <v-icon>mdi-close</v-icon>

                Quitar
              </v-btn>
            </v-col>

            <v-col cols="12">
              <ListadoDetallesSolicitudesInscripciones
                ref="listadoRef"
                :items="form.detallesSolicitudesInscripciones"
                :cargando="cargando"
                @selectItem="selectItem" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :loading="enviando"
          :disabled="enviando"
          @click.prevent="$refs.confirmacionRef1.abrir">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionRef1"
      :titulo="confirmacion1.titulo"
      :mensaje="confirmacion1.mensaje"
      :realizandoAccion="confirmacion1.realizandoAccion"
      @aceptar="confirmacion1.fnAceptar" />

    <ModalInscripciones
      ref="modalInscripcionesRef"
      :nombreRecurso="nombreItem"
      :programaId="programaId"
      :programaUniversidadId="programaUniversidadId"
      :universidadId="universidadId"
      :itemsYaSeleccionados="form.detallesSolicitudesInscripciones"
      @agregarDetallesSolicitudesInscripciones="agregarDetallesSolicitudesInscripciones" />
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import SolicitudInscripcionService from '../services/solicitud-inscripcion.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConfirmacionAccion from '../components/ConfirmacionAccion.vue';
import ListadoDetallesSolicitudesInscripciones from './ListadoDetallesSolicitudesInscripciones.vue';
import layoutMixin from '../mixins/layout.mixin';
import ModalInscripciones from './ModalInscripciones.vue';
import { ESTADOS_INSCRIPCION } from '../utils/constantes';
import { concatenar } from '../utils/funciones';

export default {
  name: 'ModalFormularioSolicitudInscripcion',
  mixins: [modalFormMixin, apiConsumerMixin, layoutMixin],
  components: {
    ConfirmacionAccion,
    ListadoDetallesSolicitudesInscripciones,
    ModalInscripciones,
  },
  props: {
    programaId: {
      type: Number,
      required: true,
    },
    programaUniversidadId: {
      type: Number,
      default: null,
    },
    universidadId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      nombreItem: 'Detalle Solicitud Inscripción',
      confirmacion1: {
        titulo: 'Guardar Solicitud de Inscripción',
        mensaje: /*html*/ `¿Está seguro que desea realizar la solicitud de inscripción? <br />Al aceptar, usted (<strong>${concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        )}</strong>) garantiza que <strong>comprobó/verificó</strong> que estos estudiantes <strong>cumplen con los requisitos académicos</strong> y que <strong>presentaron los documentos</strong> necesarios para su inscripción.<br />Si no es así, por favor, no realice la solicitud.`,
        realizandoAccion: false,
        fnAceptar: () => this.validar(this.registrar, this.editar),
      },
    };
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        programaId: this.programaId,
        programaUniversidadId: this.programaUniversidadId,
        nombreSolicitante: concatenar(
          this.$store.state.DATA_USER.nombres,
          this.$store.state.DATA_USER.pri_apellido,
          this.$store.state.DATA_USER.seg_apellido,
        ),
        solicitanteId: this.$store.state.DATA_USER.id,
        sedeId: this.$store.state.cargo_sede.sede.id,
        detallesSolicitudesInscripciones: [],
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        programaId: data.programaId,
        programaUniversidadId: data.programaUniversidadId,
        nombreSolicitante: data.nombreSolicitante,
        solicitanteId: data.solicitanteId,
        sedeId: data.sedeId,
        detallesSolicitudesInscripciones: data.detallesSolicitudesInscripciones
          .sort(
            (a, b) =>
              a.inscripcion.estudiante?.primerApellido?.localeCompare(b.inscripcion.estudiante?.primerApellido) ||
              a.inscripcion.estudiante?.segundoApellido?.localeCompare(b.inscripcion.estudiante?.segundoApellido) ||
              a.inscripcion.estudiante?.nombres?.localeCompare(b.inscripcion.estudiante?.nombres),
          )
          .map((detalle) => {
            return {
              id: detalle.id,
              inscripcionId: detalle.inscripcionId,
              estado: detalle.estado,
              estudiante: {
                id: detalle.inscripcion.estudiante.id,
                numeroDocumento: detalle.inscripcion.estudiante.numeroDocumento,
                nombres: detalle.inscripcion.estudiante.nombres,
                primerApellido: detalle.inscripcion.estudiante.primerApellido,
                segundoApellido: detalle.inscripcion.estudiante.segundoApellido,
                sexo: detalle.inscripcion.estudiante.sexo,
                telefono1: detalle.inscripcion.estudiante.telefono1,
                telefono2: detalle.inscripcion.estudiante.telefono2,
                email: detalle.inscripcion.estudiante.email,
                profesiones: detalle.inscripcion.estudiante.profesiones,
                institucion: detalle.inscripcion.estudiante.institucion,
              },
              creadoEn: detalle.creadoEn,
            };
          }),
      };
    },
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        SolicitudInscripcionService.create,
        SolicitudInscripcionService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
    agregarDetallesSolicitudesInscripciones(detallesSolicitudesInscripciones) {
      detallesSolicitudesInscripciones.forEach((detalleSolicitudInscripcion) => {
        const { estudiante } = detalleSolicitudInscripcion;

        this.form.detallesSolicitudesInscripciones.push({
          id: null,
          inscripcionId: detalleSolicitudInscripcion.id,
          estado: ESTADOS_INSCRIPCION[detalleSolicitudInscripcion.estadoInscripcion].toLowerCase(),
          estudiante: {
            id: estudiante.id,
            numeroDocumento: estudiante.numeroDocumento,
            nombres: estudiante.nombres,
            primerApellido: estudiante.primerApellido,
            segundoApellido: estudiante.segundoApellido,
            sexo: estudiante.sexo,
            telefono1: estudiante.telefono1,
            telefono2: estudiante.telefono2,
            email: estudiante.email,
            profesiones: estudiante.profesiones,
            institucion: estudiante.institucion,
          },
          creadoEn: null,
        });
      });
    },
    quitarItem(id) {
      this.form.detallesSolicitudesInscripciones = this.form.detallesSolicitudesInscripciones.filter(
        (item) => item.id !== id,
      );
      this.item = null;
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>